import Result from 'antd/lib/result'
import { captureException } from '@sentry/react'
import { useEffect } from 'react'
import { Button, paths } from '@/shared'

export const NotFoundPage = () => {
  useEffect(() => {
    captureException('Not found page')
  }, [])

  return (
    <Result
      status='404'
      title='404'
      subTitle='Sorry, the page you visited does not exist.'
      extra={
        <a href={paths.main()}>
          <Button type='primary'>Back Home</Button>
        </a>
      }
    />
  )
}
